export default {
  types: [],
  typesLoaded: false,
  locales: [],
  localesLoadedAt: 0,
}